import getSubscriptionStatus from "@helpers/getSubscriptionStatus"
import {
  addTryFirstToLocalStorage,
  setOnboardingContext,
} from "@helpers/localStorage"
import { getSession } from "@helpers/supabase"
import { redirect } from "react-router-dom"

export default async function hairstyleOnboardingLoader() {
  setOnboardingContext("hairstyle")
  addTryFirstToLocalStorage("hairstyle")

  const signedInUsersRedirect = await redirectSignedInUsers()
  if (signedInUsersRedirect) return signedInUsersRedirect

  return null
}

async function redirectSignedInUsers() {
  const { data } = await getSession()

  const userId = data?.session?.user?.id

  if (userId) {
    const subscriptionStatus = await getSubscriptionStatus(userId)

    if (subscriptionStatus === "active") {
      return redirect("/account/subscription")
    } else {
      return redirect("/checkout/plans")
    }
  }
}
